import { useEffect } from "react";
import { useState } from "react";
import { messageModal } from "../functionsGlobal";

export let typeMessage = 'success';
export let setTypeMessage =  (value) => typeMessage = value;
export let timerMessage = 5000;
export let setTimerMessage =  (value) => timerMessage = value;

export const useMessage = () => {
    const [showMessageModal, setShowMessageModal] = useState(false);
    const [textMessageModal, setTextMessageModal] = useState('');

    const resetMessage = () => {
        setShowMessageModal(false);
    }

    const isVisibleMessage = (value = '', typeMessageModal = 'success', timer) => {
        messageModal.textBody = value;
        if (timer) timerMessage = timer
        typeMessage = typeMessageModal
        setTextMessageModal(value)
        setShowMessageModal(true);
    }

    useEffect(() => {

        if(showMessageModal){
            return () => {
                messageModal.textBody = ''
                timerMessage = 5000
            }     

        }

    }, [showMessageModal])


    return {
        isVisibleMessage,
        resetMessage,
        showMessageModal,
        setShowMessageModal,
        textMessageModal
    }

}